module.exports = __webpack_public_path__ + "media/images/gallery/constellations/triangulum/tri_names-c954ecd6c701244b4439220801d0a10a.gif";